export const analyticsTabs = [
  "overview",
  "users",
  "revenue",
  "ai",
  "content",
  "pqr",
  "health",
] as const;

export type AnalyticsTab = (typeof analyticsTabs)[number];

export type AnalyticsRangePreset =
  | "last_7_days"
  | "last_30_days"
  | "last_90_days"
  | "this_month"
  | "last_month"
  | "custom";

export type AnalyticsBucket = "day" | "week";

export type AnalyticsTimeRange = {
  bucket: AnalyticsBucket;
  endDate: string;
  preset: AnalyticsRangePreset;
  startDate: string;
};

export type AnalyticsTrend = {
  changePercent: number | null;
  direction: "up" | "down" | "flat" | "unavailable";
  previousValue: number | null;
  quality: "improving" | "deteriorating" | "neutral" | "unavailable";
};

export type AnalyticsKpiMetric = {
  currentState: boolean;
  key: string;
  label: string;
  positiveDirection?: "up" | "down";
  trend?: AnalyticsTrend;
  unit: "count" | "credits" | "cents" | "usd" | "percent" | "days";
  value: number | string | null;
};

export type AnalyticsSeriesPoint = {
  date?: string;
  label?: string;
  [key: string]: number | string | null | undefined;
};

export type AnalyticsTableRow = Record<string, number | string | boolean | null | undefined>;

export type AnalyticsSnapshotResponse = {
  generatedAt: string;
  kpis?: AnalyticsKpiMetric[];
  notes: string[];
  range: AnalyticsTimeRange;
  series: Record<string, AnalyticsSeriesPoint[]>;
  tab: AnalyticsTab;
  tables: Record<string, AnalyticsTableRow[]>;
  unavailableDates: string[];
};

export type AnalyticsBudgetStatus = {
  capUSD: number;
  percent: number;
  spentUSD: number;
  status: "normal" | "warning" | "limited";
};

export type AnalyticsLiveKpis = {
  activeJobCounts: {
    exports: number;
    imports: number;
  };
  aiBudgetStatus: AnalyticsBudgetStatus;
  arpuCents: number;
  currentArrCents: number;
  currentMrrCents: number;
  flaggedUsersCount: number;
  generatedAt: string;
  openPqrTickets: number;
  paidSubscribers: number;
  runningImportJobs: number;
  topUpRevenueThisMonthCents: number;
  totalRegisteredUsers: number;
};
